import { useQuery } from '@tanstack/react-query';

import { createLetterhead } from '../../Repositories';

const letterheadRequest = createLetterhead();

/**
 * this function(query) is to get the letterhead signed url
 * @function useLetterheadGetQuery
 * @param {Object} options to be passed as query handling
 * @returns api response
 */
export function useLetterheadGetQuery(options) {
  return useQuery(['letterheadGetQuery'], () => letterheadRequest.getLetterhead(), {
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    ...options,
  });
}
